var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.userInvite.status != "submitted" && _vm.userInvite.status != "emailed"
      ? _c("div", { attrs: { id: "inviter" } }, [
          !_vm.userInvite.newProfile
            ? _c("h3", [
                _vm._v(
                  " Share your " +
                    _vm._s(_vm.userInvite.profileName) +
                    " profile with a collaborator. "
                )
              ])
            : _vm._e(),
          _vm.userInvite.newProfile && _vm.invitedRole == "Venue"
            ? _c("h3", [_vm._v(" Invite a venue to use Gobo. ")])
            : _vm._e(),
          _vm.userInvite.newProfile && _vm.invitedRole == "Artist"
            ? _c("h3", [_vm._v(" Invite an artist to use Gobo. ")])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.invitedRole) + " Name")
            ]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInvite.profileName,
                    expression: "userInvite.profileName"
                  }
                ],
                staticClass: "input",
                attrs: { type: "text", disabled: "true" },
                domProps: { value: _vm.userInvite.profileName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.userInvite, "profileName", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.invitedRole) + " Email")
            ]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInvite.email,
                    expression: "userInvite.email"
                  }
                ],
                staticClass: "input",
                attrs: { type: "text" },
                domProps: { value: _vm.userInvite.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.userInvite, "email", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Email Message")]),
            _c("div", { staticClass: "control" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInvite.message,
                    expression: "userInvite.message"
                  }
                ],
                staticClass: "textarea",
                attrs: { type: "text" },
                domProps: { value: _vm.userInvite.message },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.userInvite, "message", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "buttons is-centered" }, [
            false
              ? _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.cancel } },
                  [_vm._v("Cancel")]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                class: { "is-loading": _vm.inProgress },
                attrs: { disabled: !_vm.emailValid },
                on: { click: _vm.confirm }
              },
              [_vm._v(" Send Invite ")]
            )
          ])
        ])
      : _vm._e(),
    _vm.userInvite.status == "submitted" || _vm.userInvite.status == "emailed"
      ? _c(
          "div",
          { staticClass: "has-text-centered", attrs: { id: "invited" } },
          [
            _c("h3", [
              _vm._v(
                "An invite has been sent to " +
                  _vm._s(_vm.userInvite.email) +
                  "!"
              )
            ]),
            _c("p", [_vm._v("Thank you for sharing the Gobo experience!")]),
            _vm._m(0),
            _c("div", { staticClass: "buttons is-centered" }, [
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.resetInvite } },
                [_vm._v(" Invite another collaborator ")]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "figure" }, [
      _c("img", {
        attrs: { src: "/img/illustration-email.png", alt: "email sent" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }